@if (pending()) {
    <app-placeholder-card />
} @else if (damageReports().length > 0) {
    <app-portal-collapsible
        title="Schadensmeldungen"
        icon="damage"
    >
        @if (nbrReportsNotComplete() > 0) {
            <div
                class="pill"
                collapsibleHeading
            >
                {{ nbrReportsNotComplete() }}
            </div>
        }
        <div class="container">
            @for (damageReport of damageReports(); track damageReport.id) {
                <app-reported-damages-list-item [damageReport]="damageReport"></app-reported-damages-list-item>
                @if (!$last) {
                    <hr class="m-0" />
                }
            }
        </div>
    </app-portal-collapsible>
}
